import type { ReactNode } from "react";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-md px-4 pb-32 sm:max-w-xl sm:px-5 sm:pb-28 lg:max-w-3xl lg:px-8 lg:pb-12 xl:max-w-4xl">
      {children}
    </div>
  );
}

export function Stack({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex flex-col gap-3 sm:gap-4 ${className}`}>
      {children}
    </div>
  );
}

export function TwoCol({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-3 sm:gap-4 ${className}`}
    >
      {children}
    </div>
  );
}

export function DashboardGrid({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`grid gap-3 sm:gap-4 lg:grid-cols-2 ${className}`}>
      {children}
    </div>
  );
}
